import { render, staticRenderFns } from "./index.vue?vue&type=template&id=083f6f5d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=083f6f5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f6f5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083f6f5d')) {
      api.createRecord('083f6f5d', component.options)
    } else {
      api.reload('083f6f5d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=083f6f5d&scoped=true", function () {
      api.rerender('083f6f5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myTabs/index.vue"
export default component.exports